import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Tab, Tabs } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { AdminService } from "../../services/admin.service";
import { onFetchInstructorCourse } from "../../store/actions/InstructorCourse";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import Select from "react-select";
import toast from "react-hot-toast";
import { ArrayHelper } from "../../helpers/array.helper";
import DatePicker from "react-datepicker";
import moment from "moment";
import SideModal from "../SideModal/SideModal";
import { states } from "../../utilis/states.utils";
import { countries } from "../../utilis/country.utiils";
import { inclusiveCalc } from "../../services/gst.calculator";
import { RolesContext } from "../../routes/private.context";

interface ICreateRazorpayLinkProps {
  show: boolean;
  setShow: any;
  reload: any;
}


export default function CreateValidityExtensionModal(
  props: ICreateRazorpayLinkProps
) {
  const [finalSaveState, setFinalSaveState] = useState<any>({
    dhunguruDiscount: 0,
    totalSession: 0,
    fromHaryana: false,
  });

  const dispatch = useAppDispatch();
  const [inputStudentValue, setInputStudentValue] = useState<any>();
  const [country, setCountry] = useState<any>({});
  const [isCountryIndia, setIsCountryIndia] = useState<boolean>(false);

  const [selOption, setSelOption] = useState<any>({});

  const [state, setState] = useState<any>({});


  const [coordinators, setCoordinators] = useState<any>();


  const [enrollements, setEnrollements] = useState<any>([]);
  const [selectedEnrollment, setSelectedEnrollment] = useState<any>(null);
  const [selectedPaymentDetails, setSelectedPaymentDetails] =
    useState<any>(null);
  const [validityExtension, setValidityExtension] = useState(0);
  const [validityExtensionAmount, setValidityExtensionAmount] = useState(0);
  const [discountedPrice, setDiscountedPrice] = useState<number>(0);
  const [showDiscountedPrice, setShowDiscountedPrice] = useState(false);


  const { roles, getUserRoles } = React.useContext(RolesContext);
  let isAllowed = false;
  if (roles && roles.length > 0 && roles.find((role: any) => role.role == "validity extension dhunguru discount" && role.allowed == true)) {
    isAllowed = true;
  }



  const handelInstructorChanges = (obj: any) => {
    setSelOption(obj);
  };

  const [loading, setLoading] = useState<boolean>(false);

  const id = selOption?.value || "";


  useEffect(() => {
    if (!id) return;
    dispatch(onFetchInstructorCourse({ id }));
  }, [id, dispatch]);

  const fetchInstructorData = (inputValue: any, callback: ([]) => void) => {
    if (!inputValue) {
      callback([]);
    } else {
      setTimeout(() => {
        AdminService.getAllInstructor(inputValue).then((res) => {
          if (res.status === 200) {
            const instructors = res.data.data.map((data: any) => {
              return {
                value: data._id,
                label: `${data.firstName}  ${data.lastName} - ${data.email}`,
              };
            });
            callback(instructors);
          }
        });
      }, 1000);
    }
  };

  const fetchCoordinators = () => {
    AdminService.getAllCoordinators().then((res) => {
      if (res.status === 200) {
        const valid_coor = res.data.filter((data: any) =>
          data.adminVisibility.includes("COORDINATOR")
        );
        setCoordinators(
          valid_coor.map((data: any) => {
            return {
              value: data._id,
              label: `${data.firstName} ${data.lastName}`,
            };
          })
        );
      }
    });
  };



  useEffect(() => {
    fetchCoordinators();
  }, [id]);

  const fetchStudentData = (inputValue: any, callback: ([]) => void) => {
    if (!inputValue) {
      callback([]);
    } else {
      setTimeout(() => {
        AdminService.getAllStudents(inputValue).then((res) => {
          if (res.status === 200) {
            const students = res.data.data.map((data: any) => {
              return {
                value: data._id,
                label: `${data.firstName}  ${data.lastName} - ${data.email}`,
              };
            });
            callback(students);
          }
        });
      }, 1000);
    }
  };
  // value={extraClasses}

  const handleCoordinatorChange = (e: any, name: string) => {
    setFinalSaveState({ ...finalSaveState, [name]: e.label });
  };


  async function createValidiatyLink() {
    if (!selectedEnrollment || !selectedPaymentDetails) {
      toast.error("Please select enrollment and payment details");
      return;
    }

    if (!validityExtension || validityExtension < 1) {
      toast.error("Please select validity extension");
      return;
    }

    if (!validityExtensionAmount || validityExtensionAmount < 1) {
      toast.error("Please select validity extension amount");
      return;
    }

    if (showDiscountedPrice && (!discountedPrice || discountedPrice < 1)) {
      toast.error("Please enter valid discounted amount");
      return;
    }

    setLoading(true);

    let payload = {
      validityDays: validityExtension * 30,
      price: showDiscountedPrice ? isCountryIndia ? (discountedPrice / 1.18).toFixed(2) : discountedPrice : { validityExtensionAmount },
      state: state.value,
      country: country.value,
      gateway: "rzp",
    };

    await AdminService.createLinkForValidity(
      selectedEnrollment?.value,
      selectedPaymentDetails?.value,
      payload
    )
      .then((res) => {
        if (res.status === 200) {
          props.setShow(false);
          toast.success("Success: Link Created!");
          props.reload();
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
      });
    setLoading(false);
  }


  async function getEnrollments() {
    await AdminService.getDropDownEnrollments(
      inputStudentValue?.value,
      selOption?.value
    )
      .then((res) => {
        if (res.status == 200) {
          const enrollments = res.data?.data?.enrollments?.map((data: any) => {
            return {
              value: data?._id,
              label:
                data?.enrollmentId +
                " - " +
                data?.instrument +
                " - " +
                data?.sessions_left,
              course: data?.course,
              payment_details: data?.payment_details,
            };
          });
          setEnrollements(enrollments);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }


  useEffect(() => {
    if (
      selOption &&
      selOption.value &&
      inputStudentValue &&
      inputStudentValue.value
    ) {
      getEnrollments();
    }
  }, [selOption, inputStudentValue]);


  useEffect(() => {
    if (selectedEnrollment) {
      setSelectedPaymentDetails(null);
    }
  }, [selectedEnrollment]);


  useEffect(() => {
    if (validityExtension) {
      let base = 3000;
      let amount =
        validityExtension == 1 ? base : base + (validityExtension - 1) * 1000;

      if (isCountryIndia) {
        const gst_calc = inclusiveCalc(amount, 18, state.value === "Haryana" ? "intra" : "inter");
        amount = gst_calc.base;
      }
      setValidityExtensionAmount(amount);
    }
  }, [validityExtension]);


  const renderValidityDate = () => {
    if (!selectedPaymentDetails || !validityExtension) return "N/A";

    const selectedEnrollment_pay = selectedEnrollment?.payment_details?.find(
      (data: any) => data._id === selectedPaymentDetails.value
    );
    const validityDate = moment(selectedEnrollment_pay?.validityDate)
      .add((validityExtension * 30), "days")
      .format("DD/MM/YYYY");
    return validityDate;
  }


  return (
    <SideModal
      title={"Create Validity Extension "}
      show={props.show}
      handleClose={() => props.setShow(false)}
      body={
        <>
          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Select Guru
            </Form.Label>
            <AsyncSelect
              name="InstructorId"
              loadOptions={fetchInstructorData}
              onChange={(option) => handelInstructorChanges(option)}
              isClearable={true}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Select the Student
            </Form.Label>

            <AsyncSelect
              name="studentId"
              loadOptions={fetchStudentData}
              onChange={setInputStudentValue}
              isClearable={true}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Select Enrollment
            </Form.Label>
            <Select
              name="freshworksDetals"
              options={enrollements}
              value={selectedEnrollment}
              onChange={setSelectedEnrollment}
              isClearable={true}
            />
          </Form.Group>
          {selectedEnrollment?.payment_details &&
            selectedEnrollment?.payment_details.length > 0 && (
              <Form.Group className="mt-2">
                <Form.Label className="fw-bold text-secondary fs-12">
                  Select Payment Details (Receipt Id - Classes Left/Total
                  Classes)
                </Form.Label>
                <Select
                  name="freshworksDetals"
                  options={selectedEnrollment?.payment_details?.map(
                    (data: any) => {
                      console.log("data", data);
                      return {
                        value: data._id,
                        label:
                          data?.receipt +
                          " - " +
                          data?.classes_left +
                          "/" +
                          data?.num_classes +
                          " - " +
                          (data?.validityDate ? moment(data?.validityDate).format("DD/MM/YYYY") : "N/A")
                      };
                    }
                  )}
                  value={selectedPaymentDetails}
                  onChange={setSelectedPaymentDetails}
                  isClearable={true}
                />
              </Form.Group>
            )}
          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Country
            </Form.Label>
            <Select
              options={countries.map((country) => {
                return {
                  label: country,
                  value: country,
                };
              })}
              value={country}
              onChange={(e) => {
                setCountry(e);
                setIsCountryIndia(e?.value === "India" ? true : false);
              }}
            />
          </Form.Group>

          {isCountryIndia && (
            <Form.Group className="mt-2">
              <Form.Label className="fw-bold text-secondary fs-12">
                State(Mandatory)
              </Form.Label>
              <Select
                options={states.map((state) => {
                  return {
                    label: state,
                    value: state,
                  };
                })}
                value={state}
                onChange={setState}
              />
            </Form.Group>
          )}

          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Coordinator
            </Form.Label>
            <Select
              name="coordinatorId"
              options={coordinators}
              isClearable={true}
              onChange={(e: any) => {
                handleCoordinatorChange(e, "coordinator");
              }}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Extend Validity By (months)
            </Form.Label>
            <Form.Control
              type="number"
              name="extendValidity"
              value={validityExtension}
              onChange={(e: any) => setValidityExtension(e.target.value)}
              placeholder="Enter number of months"
              max={12}
              min={1}
              isInvalid={validityExtension < 1 || validityExtension > 12}
            />
          </Form.Group>
          {(showDiscountedPrice == false) && <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Extended Validity Amount
            </Form.Label>
            <Form.Control
              type="number"
              value={validityExtensionAmount}
              onChange={(e: any) => setValidityExtensionAmount(e.target.value)}
              placeholder="Enter amount"
              disabled
            />
          </Form.Group>}
          {isAllowed && <Form.Group className="mt-2">
            <Form.Check
              inline
              className="mt-4 fw-bold text-secondary fs-12"
              reverse
              label="Discounted Amount?"
              name="extraClassesAllowed"
              checked={showDiscountedPrice}
              onChange={(e) => setShowDiscountedPrice(e.target.checked)}
              type="checkbox"
            />
          </Form.Group>}
          {showDiscountedPrice && <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Discounted Amount(GST Inclusive)
            </Form.Label>
            <Form.Control
              type="number"
              name="discountedPrice"
              value={discountedPrice}
              onChange={(e: any) => setDiscountedPrice(e.target.value)}
              placeholder="Enter discounted amount"
            />
          </Form.Group>}




          <div
            className="bg-muted rounded-3 mt-3 p-3 fs-12"
            style={{ backgroundColor: "#f1f1f1" }}
          >
            <div className="fw-bold text-secondary">
              {isCountryIndia ? (<div>
                {" "}
                Total Price:{" "}
                {showDiscountedPrice ? (
                  <span className="text-success">
                    {" "}
                    = {((discountedPrice) / 1.18).toFixed(2)}
                  </span>)
                  : (
                    <span className="text-success">
                      {" "}
                      = {validityExtensionAmount}
                    </span>
                  )}
              </div>) : (
                <div>
                  {" "}
                  Total Price:{" "}
                  {showDiscountedPrice ? (
                    <span className="text-success">
                      {" "}
                      = {discountedPrice}
                    </span>) : (
                    <span className="text-success">
                      {" "}
                      = {validityExtensionAmount}
                    </span>
                  )}
                </div>
              )}
              <hr />
              {isCountryIndia && (
                <div>
                  {state.value === "Haryana" ? (
                    <div>
                      {" "}
                      <div>
                        {" "}
                        CGST:{" "}
                        {showDiscountedPrice ? (
                          <span className="text-success">
                            {" "}
                            {discountedPrice > 0 ? (
                              <>
                                {" "}
                                +{(((discountedPrice) / 1.18) * 0.09).toFixed(2)}
                              </>
                            ) : (
                              ``
                            )}
                          </span>) :
                          (
                            <span className="text-success">
                              {" "}
                              {validityExtensionAmount > 0 ? (
                                <>
                                  {" "}
                                  +{(validityExtensionAmount * 0.09).toFixed(2)}
                                </>
                              ) : (
                                ``
                              )}
                            </span>
                          )}
                        <div>
                          {" "}
                          SGST:{" "}
                          {showDiscountedPrice ? (
                            <span className="text-success">
                              {" "}
                              {discountedPrice > 0 ? (
                                <>
                                  {" "}
                                  +{(((discountedPrice) / 1.18) * 0.09).toFixed(2)}
                                </>
                              ) : (
                                " --- All Fields Are Required --- "
                              )}
                            </span>
                          ) : (
                            <span className="text-success">
                              {" "}
                              {validityExtensionAmount > 0 ? (
                                <>
                                  {" "}
                                  +{(validityExtensionAmount * 0.09).toFixed(2)}
                                </>
                              ) : (
                                " --- All Fields Are Required --- "
                              )}
                            </span>
                          )}
                        </div>
                        <div>
                          {" "}
                          GST:{" "}
                          {showDiscountedPrice ? (
                            <span className="text-success">
                              {" "}
                              {discountedPrice > 0 ? (
                                <>
                                  {" "}
                                  +{(((discountedPrice) / 1.18) * 0.18).toFixed(2)}
                                </>
                              ) : (
                                " --- All Fields Are Required --- "
                              )}
                            </span>
                          ) : (
                            <span className="text-success">
                              {" "}
                              {validityExtensionAmount > 0 ? (
                                <>
                                  {" "}
                                  +{(validityExtensionAmount * 0.18).toFixed(2)}
                                </>
                              ) : (
                                " --- All Fields Are Required --- "
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {" "}
                      <div>
                        {" "}
                        IGST:{" "}
                        {showDiscountedPrice ? (
                          <span className="text-success">
                            {" "}
                            {discountedPrice > 0 ? (
                              <>
                                {" "}
                                +{(((discountedPrice) / 1.18) * 0.18).toFixed(2)}
                              </>
                            ) : (
                              " --- All Fields Are Required --- "
                            )}
                          </span>
                        ) : (
                          <span className="text-success">
                            {" "}
                            {validityExtensionAmount > 0 ? (
                              <>
                                {" "}
                                +{(validityExtensionAmount * 0.18).toFixed(2)}
                              </>
                            ) : (
                              " --- All Fields Are Required --- "
                            )}
                          </span>
                        )}
                      </div>
                      <div>
                        {" "}
                        GST:{" "}
                        {showDiscountedPrice ? (
                          <span className="text-success">
                            {" "}
                            {discountedPrice > 0 ? (
                              <>
                                {" "}
                                +{(((discountedPrice) / 1.18) * 0.18).toFixed(2)}
                              </>
                            ) : (
                              " --- All Fields Are Required --- "
                            )}
                          </span>
                        ) : (
                          <span className="text-success">
                            {" "}
                            {validityExtensionAmount > 0 ? (
                              <>
                                {" "}
                                +{(validityExtensionAmount * 0.18).toFixed(2)}
                              </>
                            ) : (
                              " --- All Fields Are Required --- "
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div>
                    {" "}
                    Total Price with GST:{" "}
                    {showDiscountedPrice ? (
                      <span className="text-primary">
                        {" "}
                        {discountedPrice > 0
                          ? discountedPrice
                          : " --- All Fields Are Required --- "}
                      </span>
                    ) : (
                      <span className="text-primary">
                        {" "}
                        {validityExtensionAmount > 0
                          ? Math.round(validityExtensionAmount +
                            validityExtensionAmount * 0.18)
                          : " --- All Fields Are Required --- "}
                      </span>
                    )}
                  </div>
                  <div>
                    {" "}
                    Tentative Validity Date:{" "}
                    <span className="text-primary">
                      {" "}
                      {renderValidityDate()}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Button
            className="mt-2"
            onClick={() => createValidiatyLink()}
            disabled={loading ? true : false}
          >
            Create Payment Link
          </Button>
        </>
      }
    />
  );
}
